var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70094 2.76001C9.33746 2.12349 10.2008 1.7659 11.1009 1.7659C12.0011 1.7659 12.8644 2.12349 13.5009 2.76001C14.1375 3.39653 14.4951 4.25984 14.4951 5.16001C14.4951 6.06019 14.1375 6.92349 13.5009 7.56001L12.6276 8.43334L7.8276 13.2333L3.0276 8.43334L2.15427 7.56001C1.51775 6.92349 1.16016 6.06019 1.16016 5.16001C1.16016 4.25984 1.51775 3.39653 2.15427 2.76001C2.79079 2.12349 3.65409 1.7659 4.55427 1.7659C5.45444 1.7659 6.31775 2.12349 6.95427 2.76001L7.8276 3.63334L8.70094 2.76001Z",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeart);
export default __webpack_public_path__ + "static/media/redHeart.73314afb.svg";
export { ForwardRef as ReactComponent };